<template>
  <div class="home p-6 max-w-sm mx-auto bg-white rounded-xl shadow-md flex items-center space-x-4">
    <div class="flex-shrink-0">
      Spotify Overlay
    </div>
    <button @click="redirect('/api/login/')" class="bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-50 text-white p-2"><span class='text-xl'>Login Using Spotify</span> <i class ="fab fa-spotify text-2xl"></i></button>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  methods: {
    redirect: function(link){
      location.href = link
    }
  }
}
</script>